import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";
const theme = createTheme();

const useHeaderStyle = makeStyles(() => ({
    headerLogo: {
        color: "red",
        fontWeight: "bold",
        fontSize: "28px",
        "@media (max-width:599px)": {
            fontSize: "14px",
        },
        "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "19.6px", // 70% of 28px
        },
    },
    headerToolbar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px",
        borderBottom: "1px solid #ccc",
        "@media (max-width:599px)": {
            padding: "2px 8px",
            flexWrap: "wrap",
            gap: "2px",
        },
    },
    headerCandidateInfo: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        "& .MuiTypography-body2": {
            fontSize: "0.875rem",
            "@media (max-width:599px)": {
                fontSize: "0.58rem",
            },
            "@media (min-width: 800px) and (max-width: 898px)": {
                fontSize: "0.6125rem", // 70% of 0.875rem
            },
        },
    },
    candidateTime: {
        backgroundColor: "#0098DA",
        color: "white",
        borderRadius: "10px",
        padding: "4px 8px",
        fontSize: "12px",
        display: "inline-block",
        "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "8.4px", // 70% of 12px
            padding: "2.8px 5.6px", // 70% of original
        },
    },
    navbar: {
        backgroundColor: "black", // Changed to black to match IPMAT as per user observation
        padding: "4px 8px",
        minHeight: "40px",
        "@media (min-width: 800px) and (max-width: 898px)": {
            padding: "2px 4px",
            minHeight: "32px",
        },
        "@media (max-width:599px)": {
            padding: "2px 6px",
            minHeight: "30px",
        },
    },
    navbarContainer: {
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        alignItems: "center",
        width: "100%",
        flexDirection: "row",
        gap: "6px",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "row",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "6px",
        },
        "@media (max-width:599px)": {
            gap: "4px",
        },
    },
    navbarLeft: {
        display: "flex",
        gap: "8px",
        flexWrap: "nowrap",
        alignItems: "center",
        overflowX: "auto",
        flex: 1,
        "&::-webkit-scrollbar": {
            height: "3px",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "rgba(255,255,255,0.3)",
            borderRadius: "3px",
        },
        "@media (max-width:599px)": {
            gap: "2px",
            maxWidth: "calc(100vw - 110px)",
        },
    },
    navbarButton: {
        backgroundColor: "#347dc0 !important",
        fontWeight: "bold",
        color: "white !important",
        fontSize: "13px !important",
        "@media (max-width:599px)": {
            fontSize: "9px !important",
        },
        "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "9.1px !important", // 70% of 13px
        },
    },
    navbarLanguage: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        flexShrink: 0,
        "@media (max-width:599px)": {
            gap: "4px",
        },
    },
    navbarLanguageText: {
        color: "white",
        fontWeight: "bold",
        fontSize: "13px !important",
        "@media (max-width:599px)": {
            fontSize: "9px !important",
        },
        "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "9.1px !important", // 70% of 13px
        },
    },
    profileImagecontainer: {
        width: "80px",
        display: "flex",
        background: "#E0E0E2",
        borderRadius: "10px",
        flexShrink: 0,
        "@media (max-width:599px)": {
            width: "48px",
        },
        "@media (min-width: 800px) and (max-width: 898px)": {
            width: "70px",
        },
    },
    profileImage: {
        maxWidth: "100%",
        aspectRatio: "1 / 1",
        borderRadius: "10px",
    },
    sectionPalette: {
        display: "flex",
        overflowX: "auto",
        overflowY: "hidden",
        flexDirection: "row",
        gap: "6px",
        flexWrap: "nowrap",
        alignSelf: "baseline",
        "&::-webkit-scrollbar": {
            height: "3px",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "rgba(255,255,255,0.3)",
            borderRadius: "3px",
        },
    },
    selectedQuestion: {
        width: "115px !important",
        background: "#4565B7 !important",
        borderRadius: "6px !important",
        color: "#FFF !important",
        fontFamily: "'Jost', sans-serif",
        fontSize: "13px !important",
        fontStyle: "normal !important",
        fontWeight: "700 !important",
        lineHeight: "normal !important",
        textTransform: "capitalize !important",
        border: "1px solid  #4565B7 !important",
        boxShadow: "none",
        boxShadow:
            "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
        "&:hover": {
            background: "#4565B7 !important",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "0.7rem",
        },
        "@media (max-width:599px)": {
            fontSize: "0.58rem !important",
            width: "80px !important",
            minHeight: "26px !important",
            padding: "2px !important",
        },
        "@media (min-width:600px) and (max-width:768px)": {
            fontSize: "0.7rem !important",
        },
        "@media (min-width:769px) and (max-width:1100px)": {
            fontSize: "0.7rem !important",
        },
        "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "9.1px !important", // 70% of 13px
            width: "80.5px !important", // 70% of 115px
        },
    },
    unselectedQuestion: {
        width: "115px !important",
        background: "#FFF !important",
        border: "1px solid  #303030 !important",
        borderRadius: "6px !important",
        color: "#000 !important",
        fontFamily: "'Jost', sans-serif !important",
        fontSize: "13px !important",
        fontStyle: "normal !important",
        fontWeight: "700 !important",
        lineHeight: "normal !important",
        textTransform: "capitalize !important",
        boxShadow: "none !important",
        "&:hover": {
            background: "#4565B7 !important",
            color: "#FFF !important",
            border: "1px solid  #4565B7 !important",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "0.7rem",
        },
        "@media (max-width:599px)": {
            fontSize: "0.58rem !important",
            width: "80px !important",
            minHeight: "26px !important",
            padding: "2px !important",
        },
        "@media (min-width:600px) and (max-width:768px)": {
            fontSize: "0.7rem !important",
        },
        "@media (min-width:769px) and (max-width:1100px)": {
            fontSize: "0.7rem !important",
        },
        "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "9.1px !important", // 70% of 13px
            width: "80.5px !important", // 70% of 115px
        },
    },
    modal: {
        display: "flex",
        alignItems: "flex-end",
        alignContent: "flex-end",
        justifyContent: "center",
        padding: theme.spacing(2),
        fontFamily: "'Jost', sans-serif",
    },
    modalContainer: {
        height: "87.5%",
        width: "95%",
        flexDirection: "column",
        alignItems: "center",
        flexWrap: "nowrap",
        backgroundColor: "#4565B7",
        margin: theme.spacing(1),
        padding: theme.spacing(2),
    },
    modalHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    modalTitle: {
        fontFamily: "'Jost', sans-serif",
        color: `${theme.palette.background.paper}`,
        fontSize: "1.5rem",
        "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "1.05rem", // 70% of 1.5rem
        },
    },
    modalButton: {
        fontFamily: "'Jost', sans-serif !important",
        fontSize: "18px !important",
        fontWeight: "400 !important",
        backgroundColor: `${theme.palette.background.paper} !important`,
        color: "red !important",
        "&:hover": {
            backgroundColor: "red !important",
            color: `${theme.palette.background.paper} !important`,
        },
        "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "12.6px !important", // 70% of 18px
        },
    },
    modalContent: {
        height: "85%",
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        overflow: "auto",
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2),
        "& img": {
            width: "100% !important",
            height: "auto !important",
            maxWidth: "100%", // Ensures responsiveness
        },
        fontSize: "1rem",
        "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "0.7rem", // 70% of 1rem
        },
    },
    transparentbtn: {
        width: "115px !important",
        background: "#4565B7 !important",
        borderRadius: "6px !important",
        color: "#FFF !important",
        fontFamily: "'Jost', sans-serif",
        fontSize: "13px !important",
        fontStyle: "normal !important",
        fontWeight: "700 !important",
        lineHeight: "normal !important",
        textTransform: "capitalize !important",
        border: "1px solid  #4565B7 !important",
        boxShadow: "none",
        boxShadow:
            "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
        "&:hover": {
            background: "#4565B7 !important",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "0.7rem",
        },
        "@media (max-width:599px)": {
            fontSize: "0.58rem !important",
        },
        "@media (min-width:600px) and (max-width:768px)": {
            fontSize: "0.7rem !important",
        },
        "@media (min-width:769px) and (max-width:1100px)": {
            fontSize: "0.7rem !important",
        },
        "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "9.1px !important", // 70% of 13px
            width: "80.5px !important", // 70% of 115px
        },
    },
}));

export default useHeaderStyle;